import { Column, Row } from "@hightouch/htui";
import {
  CrumbBarEnd,
  MiniNavTrigger,
  useCrumbBar,
  useIsMiniNavCollapsed,
} from "src/components/layout/nav/mini-nav/mini-nav-context";
import { usePageCard } from "src/components/layout/page-card-top-bar";
import { Skeleton } from "src/components/loading";

export const PageContentSkeleton = () => {
  // In place of a page, it holds the crumb bar's row, so the collapsed sidebar's toggle sits where the page's bar will hold it.
  // Inside a card, the card's own bar already holds it.
  const isCrumbBar = useCrumbBar(!usePageCard().isInCard);
  const isCollapsed = useIsMiniNavCollapsed();
  return (
    <Column flex={1}>
      {isCrumbBar && (
        // The page card's own inset, then its crumb bar's.
        <Row pt={2} pl={0.5} pr={2}>
          <Row
            data-nav-toggle-row
            flex={1}
            align="center"
            minHeight={10}
            py={3}
            pl={6}
            pr={6}
          >
            {isCollapsed && <MiniNavTrigger />}
            {/* Holds the agent panel's toggle too, so a panel that outlives the page keeps its spot while the next one loads. */}
            <CrumbBarEnd />
          </Row>
        </Row>
      )}
      <Column gap={6} p={6} flex={1}>
        <Column gap={2}>
          <Skeleton height={24} width={200} />
          <Skeleton height={16} width={120} />
        </Column>
        <Column gap={4}>
          <Skeleton height={120} borderRadius={8} />
          <Skeleton height={120} borderRadius={8} />
        </Column>
      </Column>
    </Column>
  );
};
